export const analysisStrings: Record<string, { en: string; he: string }> = {
  "onboarding.analyzing.title": {
    en: "Qotta is analyzing your website",
    he: "Qotta מנתחת את האתר שלך",
  },
  "onboarding.analyzing.prefix": { en: "We're diving deep into", he: "אנחנו חוקרים לעומק את" },
  "onboarding.analyzing.suffix": {
    en: "to understand your business, services, pricing and customer journey.",
    he: "כדי להבין את העסק, השירותים, התמחור ומסע הלקוח שלך.",
  },
  "onboarding.analyzing.wait": {
    en: "This usually takes several minutes.",
    he: "התהליך נמשך בדרך כלל כמה דקות.",
  },
  "onboarding.analyzing.activityLabel": { en: "The research journey", he: "מסע המחקר" },
  "onboarding.activity.business": { en: "Understanding your business", he: "הבנת העסק שלך" },
  "onboarding.activity.offerings": {
    en: "Mapping products & services",
    he: "מיפוי מוצרים ושירותים",
  },
  "onboarding.activity.pricing": { en: "Researching market pricing", he: "מחקר מחירי השוק" },
  "onboarding.activity.journey": {
    en: "Designing your customer journey",
    he: "תכנון מסע הלקוח שלך",
  },
  "onboarding.activity.preview": { en: "Preparing your Qotta", he: "הכנת ה-Qotta שלך" },
  "onboarding.analysis.coffee": {
    en: "Feel free to grab a coffee while Qotta does the research.",
    he: "אפשר להכין קפה בזמן ש-Qotta עושה את המחקר.",
  },
  "onboarding.analysis.stageNote": {
    en: "A look at the research process. Stages are illustrative; analysis time varies.",
    he: "מבט על תהליך המחקר. השלבים להמחשה; זמן הניתוח משתנה.",
  },
  "onboarding.analysis.keepOpen": {
    en: "Just keep this page open while Qotta finishes. Your experience will appear here when it's ready.",
    he: "חשוב להשאיר את הדף פתוח עד ש-Qotta תסיים. החוויה שלך תופיע כאן כשהיא תהיה מוכנה.",
  },
  "onboarding.analysis.team": { en: "The Qotta team", he: "צוות Qotta" },
  "onboarding.analysis.insightTitle": { en: "A little Qotta insight", he: "תובנה קטנה מ-Qotta" },
  "onboarding.analysis.pause": { en: "Pause insights", he: "השהיית התובנות" },
  "onboarding.analysis.resume": { en: "Resume insights", he: "המשך התובנות" },
  "onboarding.analysis.insight.0": {
    en: "Visitors often want a sense of price before a sales conversation. Qotta helps you give them a useful starting point.",
    he: "מבקרים רוצים לעיתים להבין את סדר הגודל של המחיר לפני שיחת מכירה. Qotta עוזרת לתת להם נקודת התחלה שימושית.",
  },
  "onboarding.analysis.insight.1": {
    en: "A preliminary range starts the conversation. It gives customers direction while leaving room for your team's final quote.",
    he: "טווח ראשוני פותח את השיחה. הוא נותן ללקוחות כיוון ומשאיר מקום להצעת המחיר הסופית של הצוות.",
  },
  "onboarding.analysis.insight.2": {
    en: "Thoughtful Discovery questions help visitors clarify what they need, so your team receives more focused enquiries.",
    he: "שאלות Discovery מחושבות עוזרות למבקרים להבהיר מה הם צריכים, כדי שהצוות יקבל פניות ממוקדות יותר.",
  },
  "onboarding.analysis.insight.3": {
    en: "Start the first sales conversation with context. Qotta brings the visitor's project choices along with their enquiry.",
    he: "התחילו את שיחת המכירה הראשונה עם הקשר. Qotta מצרפת לפנייה את בחירות המבקר לגבי הפרויקט.",
  },
  "onboarding.analysis.insight.4": {
    en: "Your next opportunity may already be on your website. A helpful next step gives existing visitors another reason to engage.",
    he: "ההזדמנות הבאה אולי כבר נמצאת באתר. צעד המשך מועיל נותן למבקרים הקיימים סיבה נוספת להתעניין.",
  },
  "onboarding.analysis.insight.5": {
    en: "Let visitors explore their needs before asking for contact details. Useful information can make that next step feel more natural.",
    he: "אפשרו למבקרים לבחון את הצרכים שלהם לפני בקשת פרטי קשר. מידע שימושי יכול להפוך את הצעד הבא לטבעי יותר.",
  },
  "onboarding.analysis.insight.6": {
    en: "Different projects deserve different ranges. Qotta helps connect a customer's choices to the factors that shape the price.",
    he: "פרויקטים שונים מצריכים טווחים שונים. Qotta עוזרת לחבר בין בחירות הלקוח לגורמים שמשפיעים על המחיר.",
  },
  "onboarding.analysis.insight.7": {
    en: "Qotta is designed to turn anonymous browsing into a focused enquiry, with a clearer project behind every conversation.",
    he: "Qotta נועדה להפוך גלישה אנונימית לפנייה ממוקדת, עם תמונה ברורה יותר של הפרויקט מאחורי כל שיחה.",
  },
  "onboarding.analysis.insight.8": {
    en: "You stay in control. Review and refine your services, pricing and Discovery questions to reflect how your business works.",
    he: "השליטה נשארת בידיך. אפשר לבדוק ולדייק את השירותים, התמחור ושאלות ה-Discovery בהתאם לאופן שבו העסק פועל.",
  },
  "onboarding.analysis.insight.9": {
    en: "Today's configuration is a starting point. Your team's expertise can shape it into an experience that fits your business precisely.",
    he: "התצורה של היום היא נקודת התחלה. המומחיות של הצוות יכולה להפוך אותה לחוויה שמתאימה לעסק במדויק.",
  },
  "onboarding.analysis.insight.10": {
    en: "Your business comes first. Qotta researches your website before building a Discovery journey around what you offer.",
    he: "העסק שלך קודם לכול. Qotta חוקרת את האתר לפני בניית מסע Discovery סביב ההיצע שלך.",
  },
  "onboarding.analysis.insight.11": {
    en: "A helpful estimate gives your sales team something concrete to discuss: the customer's priorities, scope and next steps.",
    he: "אומדן מועיל נותן לצוות המכירות בסיס ממשי לשיחה: סדרי העדיפויות של הלקוח, היקף הפרויקט והצעדים הבאים.",
  },
};
